import { Box, Checkbox, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useContext } from "react";
import { ConfirmationContext } from "../contexts/ConfirmationContext";

export default function IncludedAttachments() {
  const {
    includeWireInstructions,
    includeEscrowAgreement,
    setIncludeWireInstructions,
    setIncludeEscrowAgreement,
    escrowAgreementAsWord,
    setEscrowAgreementAsWord
  } = useContext(ConfirmationContext);

  return (
      <Box paddingLeft={3}>
        <FormLabel component="legend">Included attachments</FormLabel>
        <FormGroup>
          <FormControlLabel
              control={
                <Checkbox
                    checked={includeWireInstructions}
                    onChange={() => setIncludeWireInstructions(!includeWireInstructions)}
                />
              }
              label="Wire instructions"
          />

          <Box display="flex" alignItems="center">
            <FormControlLabel
                control={
                  <Checkbox
                      checked={includeEscrowAgreement}
                      onChange={() => setIncludeEscrowAgreement(!includeEscrowAgreement)}
                  />
                }
                label="Escrow Agreement - Deposit"
                sx={{ marginRight: 2 }}
            />
            {includeEscrowAgreement && (
                <RadioGroup
                    row
                    name="escrowAgreementFormat"
                    onChange={(e, s) => setEscrowAgreementAsWord(s === "word")}
                >
                  <FormControlLabel checked={!escrowAgreementAsWord} value="pdf" control={<Radio />} label="PDF" />
                  <FormControlLabel checked={escrowAgreementAsWord} value="word" control={<Radio />} label="Word Document" />
                </RadioGroup>
            )}
          </Box>
        </FormGroup>
      </Box>
  );
}
